import API_CONFIG from '../../config/api.config';

interface DatabaseStats {
    size_bytes: number;
    size_mb: number;
    last_modified: number;
}

export const systemAdminService = {
    /**
     * Get database statistics from server
     */
    async getDatabaseStats(): Promise<DatabaseStats> {
        const token = localStorage.getItem('auth_token');
        const response = await fetch(`${API_CONFIG.python.apiUrl}/system/database/stats`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error('Failed to fetch stats');
        }

        return response.json();
    },

    /**
     * Download database backup
     */
    async downloadBackup(): Promise<void> {
        const token = localStorage.getItem('auth_token');
        const response = await fetch(`${API_CONFIG.python.apiUrl}/system/database/backup`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error('Failed to download backup');
        }

        const blob = await response.blob();

        // Create download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const date = new Date().toISOString().split('T')[0];
        link.setAttribute('download', `vatli365-backup-${date}.db`);
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.remove();
        window.URL.revokeObjectURL(url);
    },

    /**
     * Restore database from backup
     * @param file The database file to restore
     */
    async restoreDatabase(file: File): Promise<void> {
        const token = localStorage.getItem('auth_token');
        const formData = new FormData();
        formData.append('file', file);

        const response = await fetch(`${API_CONFIG.python.apiUrl}/system/database/restore`, {
            method: 'POST',
            body: formData,
            headers: {
                'Authorization': `Bearer ${token}`
                // Note: Content-Type is set automatically by fetch when using FormData
            }
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.detail || 'Failed to restore database');
        }
    }
};
